import { render, staticRenderFns } from "./achievementMultipleScore.vue?vue&type=template&id=38edb4be&scoped=true"
import script from "./achievementMultipleScore.vue?vue&type=script&lang=js"
export * from "./achievementMultipleScore.vue?vue&type=script&lang=js"
import style0 from "./achievementMultipleScore.vue?vue&type=style&index=0&id=38edb4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38edb4be",
  null
  
)

export default component.exports